import { Card, DatePicker, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { setPageTitle, setSelectedMenuItemKeys } from '../../../../../redux/reducer/antd-layout.reducer';
import { useEffect, useState } from 'react';
import { Form, Button } from 'antd';
import { networkCall } from '../../../../../util/network-call/network-call';
import { showDefaultErrorMessages } from '../../../../../util/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../redux/reducer/alert-message.reducer';
import { tranformAPIValidationErrorToAntDValidationMessage } from '../../../../../util/validation/transform-api-validation-errors-to-antd-validation-messsages';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import { SelectOption } from '../../../../../constant/type/select-option.type';
import { CourseTypeEnum } from '../../../../../constant/enum/course-type.enum';
import { Education } from '../../../../../constant/type/education.type';
import dayjs from 'dayjs';


export const CompanyAdminCourseAdd = () => {

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const loaderData: any = useLoaderData();
    const [educationOptions, setEducationOptions] = useState<SelectOption[]>([]);
    const [requireDeadline, setRequireDeadline] = useState(false);
    const courseTypeOptions: SelectOption[] = [
        {
            label: 'Kötelező éves',
            value: CourseTypeEnum.AnnualMandatory
        },
        {
            label: 'Gyakorlás',
            value: CourseTypeEnum.Practice
        }
    ];

    const typeChanged = () => {
        const type = form.getFieldValue('type');

        if(type === CourseTypeEnum.Practice) {
            setRequireDeadline(false);
        } else {
            setRequireDeadline(true);
        }
    };

    const todayPlusOneWeek = dayjs().add(7, 'day').startOf('day');

    const disabledDate = (currentDate: dayjs.Dayjs) => {
        return currentDate.startOf('day').isBefore(todayPlusOneWeek);
    };

    const onFinish = async (values: any) => {

        dispatch(clearAlertMessage());
        dispatch(showAlertMessage({
            alertMessageType: 'loading',
            alertMessageText: 'Kérés folyamatban...'
        }));
 
        const response = await networkCall(`/users/${ loaderData.userId }/courses`, {
            method: 'POST',
            body: {
                type: values.type,
                deadline: values.deadline ? `${ values.deadline.get('year') }-${ values.deadline.get('month') + 1 }-${ values.deadline.get('date') }` : undefined,
                educationId: values.educationId
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if(messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: 'Ismeretlen hiba történt. Kérjük próbálja újra!'
        };

        if (response.status === 201 && response?.data?.course) {

            alertMessageState.alertMessageText = 'Mentés sikeres.';
            alertMessageState.alertMessageType = 'success';
            navigate(`/cms/company-admin/courses/edit/${ response.data.course?.id }`);

        }else if(response.status === 400){

            switch (response.data.code) {

                case 2000:
                    alertMessageState.alertMessageText = 'Hibásan megadott beviteli mezők.';
                    const validationErrors = tranformAPIValidationErrorToAntDValidationMessage(response.data?.data);
                    form.setFields(validationErrors);
                    break;

            }

        }else if(response.status === 404){

            switch (response.data.code) {

                case 3001:
                    alertMessageState.alertMessageText = 'A felhasználó nem létezik vagy nincs jogosultsága kurzusrt hozzáadni.';
                    const validationErrors = tranformAPIValidationErrorToAntDValidationMessage(response.data?.data);
                    form.setFields(validationErrors);
                    break;

            }

        }else{
            alertMessageState.alertMessageText = 'Ismeretlen hiba történt. Kérjük próbálja újra!';
        }

        dispatch(showAlertMessage(alertMessageState));

    }

    useEffect(() => {

        const messageShowed = showDefaultErrorMessages(loaderData.getEducationsResponse);
        if(messageShowed) return;

        if(loaderData.getEducationsResponse?.status === 200 && loaderData.getEducationsResponse?.data?.educations) {
            const _educationOptions: SelectOption[] = [];
            for (const education of (loaderData.getEducationsResponse.data.educations as Education[])) {
                _educationOptions.push({
                    label: education.name,
                    value: education.id
                })
            }

            setEducationOptions(_educationOptions);

            return;
        }

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: 'Ismeretlen hiba történt a licenszek listázása során. Kérjük próbálja újra!'
        };

        dispatch(showAlertMessage(alertMessageState));

    }, [loaderData.getEducationsResponse, dispatch]);

    useEffect(() => {
        dispatch(setSelectedMenuItemKeys(['0']));
        dispatch(setPageTitle('Új kurzus hozzáadása'));
    }, [dispatch]);

    return (
        <Card>
            
            <Form
                form={form}
                onFinish={onFinish}
                layout='vertical'
            >

                <Form.Item
                    label='Oktatás'
                    name='educationId'
                    rules={[{required: true, message: 'Válasszon oktatást!'}]}
                >
                    <Select
                        showSearch
                        placeholder="Válasszon oktatást!"
                        options={educationOptions}
                    />
                </Form.Item>

                <Form.Item
                    label='Típus'
                    name='type'
                    rules={[{required: true, message: 'Válasszon típust!'}]}
                >
                    <Select
                        showSearch
                        placeholder="Válasszon típust!"
                        onChange={typeChanged}
                        options={courseTypeOptions}
                    />
                </Form.Item>

                <Form.Item
                    name="deadline"
                    label="Határidő"
                    rules={[{required: requireDeadline, message: 'Válasszon határidőt!'}]}
                >
                    <DatePicker disabledDate={disabledDate} />
                </Form.Item>

                <Form.Item>
                    <Link to={loaderData.userId  ? `/cms/company-admin/users/${ loaderData.userId }/courses` : '/cms/company-admin/users/list'}>
                        <Button type="default" htmlType="button">
                            Vissza
                        </Button>
                    </Link>
                    <Button type='primary' htmlType='submit' style={{float: 'right'}}>
                        Mentés
                    </Button>
                </Form.Item>
                        
            </Form>

        </Card>
    )
}